export default {"src":"/_next/static/media/emailContact.7feaec4f.svg","height":22,"width":29,"blurWidth":0,"blurHeight":0};